import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CheckSmartTvContainer = styled.div`
    background-color: ${COLORS.BgSurface};
    padding: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
`;

export const ContentWrapper = styled(FullWidthListContainer)`
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: nowrap;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;

export const ControlWrapper = styled.div`
    flex-wrap: nowrap;
    gap: 8px;
    white-space: nowrap;
    ${FONTS.MediumS};

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        justify-content: space-between;
    }
`;
